import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { AuthService } from './services/auth.service';

export const MOTIVO_SEM_PROPRIEDADE = 'sem-propriedade';

/** Telas que continuam abertas enquanto o cliente não tem a primeira propriedade. */
const LIBERADAS_SEM_PROPRIEDADE = ['/propriedades/nova', '/meu-perfil', '/sem-acesso'];

/**
 * Prende o usuário no passo pendente do primeiro acesso: quem pode cadastrar
 * propriedade vai para o cadastro; quem não pode, para a tela de bloqueio.
 */
export const acaoRequeridaGuard: CanActivateChildFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const sessao: Observable<boolean> = auth.usuario ? of(true) : auth.verificarSessao();

  return sessao.pipe(
    map(() => {
      const arvore = router.parseUrl(state.url);
      const caminho = '/' + (arvore.root.children['primary']?.segments.map(s => s.path).join('/') ?? '');

      switch (auth.acaoRequerida()) {
        case 'cadastrar_primeira_propriedade':
          return LIBERADAS_SEM_PROPRIEDADE.includes(caminho) || router.createUrlTree(['/propriedades/nova']);

        case 'sem_propriedade_vinculada': {
          const naTelaDeBloqueio = caminho === '/sem-acesso' && arvore.queryParams['motivo'] === MOTIVO_SEM_PROPRIEDADE;

          return naTelaDeBloqueio
            || caminho === '/meu-perfil'
            || router.createUrlTree(['/sem-acesso'], { queryParams: { motivo: MOTIVO_SEM_PROPRIEDADE } });
        }

        default:
          return true;
      }
    }),
  );
};
